import { render, staticRenderFns } from "./EthnicBackground.vue?vue&type=template&id=52758bd8"
import script from "./EthnicBackground.vue?vue&type=script&lang=js"
export * from "./EthnicBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports